import Wrapper from "../../layout/Wrapper";
import RedisComponent from "../../screens/redis";

import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
  title: "Redis",
  description: "",
};

export default function Redis() {
  return (
    <Wrapper>
    	<MetaComponent meta={metadata} />
      	<RedisComponent />
    </Wrapper>
  );
}